import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useReducer, useEffect, useCallback, useMemo } from 'react';
import { entityToLayout } from '../../services/utilities/entity-to-layout.esm.js';
import { mergeLayouts } from '../../services/utilities/merge-layouts.esm.js';
import { sameArray } from '../../utilities/same-array.esm.js';
import { ActionTypes } from './reducer/action-types.esm.js';
import { reducer } from './reducer/reducer.esm.js';
import { utils } from '@costar/theme-ui';
import { LayoutType } from '../../types/layouts.esm.js';

function useOrchestrator(props) {
  var loadLayouts = props.loadLayouts,
    input = props.layouts,
    resources = props.resources;
  if (!(input !== null && input !== void 0 && input.length)) {
    throw new Error("No layout definition provided");
  }
  var _useReducer = useReducer(reducer, {
      layouts: undefined,
      entities: undefined
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(function () {
    if (state.entities === undefined) {
      return;
    }
    if (state.layouts === undefined) {
      var databaseLayouts = state.entities.map(entityToLayout(resources, input));
      var _layouts = mergeLayouts(databaseLayouts, input);
      dispatch({
        type: ActionTypes.Initialize,
        layouts: _layouts
      });
    }
  }, [input, resources, state.entities, state.layouts]);
  useEffect(function () {
    var _state$layouts$find, _input$find;
    if (state.layouts === undefined) {
      return;
    }
    var oldDefaultFields = (_state$layouts$find = state.layouts.find(function (l) {
      return l.type === LayoutType.Default;
    })) === null || _state$layouts$find === void 0 ? void 0 : _state$layouts$find.fields;
    var newDefaultFields = (_input$find = input.find(function (l) {
      return l.type === LayoutType.Default;
    })) === null || _input$find === void 0 ? void 0 : _input$find.fields;
    if (sameArray(oldDefaultFields, newDefaultFields)) {
      return;
    }
    dispatch({
      type: ActionTypes.NewDefaultFields,
      fields: newDefaultFields
    });
  }, [input, state.layouts]);
  useEffect(function () {
    var getLayouts = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var entities;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              entities = [];
              if (!loadLayouts) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return loadLayouts();
            case 4:
              entities = _context.sent;
            case 5:
              dispatch({
                type: ActionTypes.UpdateEntities,
                entities: entities
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getLayouts() {
        return _ref.apply(this, arguments);
      };
    }();
    getLayouts();
  }, [loadLayouts]);
  var setLayouts = useCallback(function (layouts) {
    dispatch({
      type: ActionTypes.Update,
      layouts: layouts
    });
  }, []);
  var result = useMemo(function () {
    return {
      layouts: state.layouts,
      setLayouts: setLayouts
    };
  }, [setLayouts, state.layouts]);

  //Making it SSR compatible handling
  if (!utils.isBrowser) {
    return {
      layouts: state.layouts || input,
      setLayouts: setLayouts
    };
  }
  return result;
}

export { useOrchestrator };
//# sourceMappingURL=orchestrator.esm.js.map
